import React, { useEffect, useState } from 'react';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';
import axios from '../../axios/axiosconf';
import { Link } from 'react-router-dom';
import Loading from '../general/Loading';
import Unauthorized from '../general/Unauthorized';

const hoyLocal = () => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

const tienePermisoReportes = (userdata) => {
    if (userdata.permissions && Array.isArray(userdata.permissions)) {
        return userdata.permissions.some((p) =>
            ['verReportes', 'ver_listado_facturas', 'verReportePacientes'].includes(p.slug)
        );
    }
    if (!userdata.up) return false;
    return userdata.up.includes('verReportes')
        || userdata.up.includes('ver_listado_facturas')
        || userdata.up.includes('verReportePacientes');
};

function ExportarSiigo() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [exportando, setExportando] = useState('');

    const [tercerosDesde, setTercerosDesde] = useState(hoyLocal());
    const [tercerosHasta, setTercerosHasta] = useState(hoyLocal());
    const [tercerosTodos, setTercerosTodos] = useState(false);

    const [facturasDesde, setFacturasDesde] = useState(hoyLocal());
    const [facturasHasta, setFacturasHasta] = useState(hoyLocal());
    const [facturasUsuario, setFacturasUsuario] = useState('');
    const [facturasDebito, setFacturasDebito] = useState('');
    const [facturasCredito, setFacturasCredito] = useState('');

    const [ncDesde, setNcDesde] = useState(hoyLocal());
    const [ncHasta, setNcHasta] = useState(hoyLocal());
    const [ncUsuario, setNcUsuario] = useState('');
    const [ncDebito, setNcDebito] = useState('');
    const [ncCredito, setNcCredito] = useState('');

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));
        if (!tienePermisoReportes(userdata)) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then((response) => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));

        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then((response) => {
                if (response.status === 200) {
                    setUsuarios(response.data || []);
                }
            })
            .catch(() => setUsuarios([]));
    }, []);

    const descargarArchivo = async (url, params, key, filenameFallback, { requireFechas = true } = {}) => {
        if (requireFechas && (!params.fecha_inicio || !params.fecha_fin)) {
            alert('Seleccione fecha inicio y fecha fin.');
            return;
        }
        setExportando(key);
        try {
            const response = await axios.get(url, {
                params,
                responseType: 'blob',
            });
            const disposition = response.headers['content-disposition'] || '';
            const match = disposition.match(/filename="?([^"]+)"?/i);
            const filename = match ? match[1] : filenameFallback;
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            const data = error.response?.data;
            if (data instanceof Blob) {
                const text = await data.text();
                try {
                    const json = JSON.parse(text);
                    alert(json.message || json.error || 'No se pudo generar el archivo.');
                } catch (e) {
                    alert('No se pudo generar el archivo.');
                }
            } else {
                alert(error.response?.data?.error || 'No se pudo generar el archivo.');
            }
        } finally {
            setExportando('');
        }
    };

    const exportarTerceros = () => {
        const params = tercerosTodos
            ? { todos: 1 }
            : { fecha_inicio: tercerosDesde, fecha_fin: tercerosHasta };
        descargarArchivo(
            '/reportes/siigo/terceros',
            params,
            'terceros',
            'Terceros_Siigo.xlsx',
            { requireFechas: !tercerosTodos }
        );
    };

    const exportarFacturas = () => {
        const params = { fecha_inicio: facturasDesde, fecha_fin: facturasHasta };
        if (facturasUsuario) params.usuario_id = facturasUsuario;
        if (facturasDebito.trim()) params.codigo_debito = facturasDebito.trim();
        if (facturasCredito.trim()) params.codigo_credito = facturasCredito.trim();
        descargarArchivo('/reportes/siigo/facturas', params, 'facturas', 'ComprobanteContable1.xlsx');
    };

    const exportarNc = () => {
        const params = { fecha_inicio: ncDesde, fecha_fin: ncHasta };
        if (ncUsuario) params.usuario_id = ncUsuario;
        if (ncDebito.trim()) params.codigo_debito = ncDebito.trim();
        if (ncCredito.trim()) params.codigo_credito = ncCredito.trim();
        descargarArchivo('/reportes/siigo/notas-credito', params, 'nc', 'Report1ComprobanteContableNC.xlsx');
    };

    if (!loggedIn) {
        return <Loading />;
    }

    if (!hasPermission) {
        return <Unauthorized />;
    }

    const selectorUsuario = (id, value, onChange) => (
        <div className="form-group">
            <label htmlFor={id}>Usuario activo</label>
            <select
                id={id}
                className="form-control form-control-sm"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Todos</option>
                {usuarios.map((u) => (
                    <option key={u.id} value={u.id}>{u.name}</option>
                ))}
            </select>
        </div>
    );

    const camposDebitoCredito = (prefix, debito, setDebito, credito, setCredito) => (
        <div className="row">
            <div className="col-6">
                <div className="form-group">
                    <label htmlFor={`${prefix}Debito`}>Débito</label>
                    <input
                        id={`${prefix}Debito`}
                        type="text"
                        className="form-control form-control-sm"
                        value={debito}
                        onChange={(e) => setDebito(e.target.value)}
                        placeholder="Ej: 13"
                        maxLength={20}
                    />
                </div>
            </div>
            <div className="col-6">
                <div className="form-group">
                    <label htmlFor={`${prefix}Credito`}>Crédito</label>
                    <input
                        id={`${prefix}Credito`}
                        type="text"
                        className="form-control form-control-sm"
                        value={credito}
                        onChange={(e) => setCredito(e.target.value)}
                        placeholder="Ej: 41"
                        maxLength={20}
                    />
                </div>
            </div>
            <div className="col-12">
                <small className="text-muted d-block mb-2" style={{ marginTop: '-6px' }}>
                    Opcional. Si los deja vacíos se usan las cuentas del asiento SmileWEB.
                </small>
            </div>
        </div>
    );

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="reports" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item active">Exportar a Siigo</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Exportar a Software Contable</h1>
                                    <p className="dash-subtitle mb-0">
                                        Excel (.xlsx) para importar terceros y comprobantes en Siigo
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/estadisticas" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-4 mb-4">
                                <div className="card h-100">
                                    <div className="card-header" style={{ background: '#eaeaea' }}>
                                        <h3 className="card-title mb-0">
                                            <i className="fas fa-users mr-2"></i>Terceros (pacientes)
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-muted small">
                                            Incluye pacientes y empresas registrados en el rango de fechas (o todos si marca la opción).
                                        </p>
                                        <div className="form-group">
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id="tercerosTodos"
                                                    checked={tercerosTodos}
                                                    onChange={(e) => setTercerosTodos(e.target.checked)}
                                                />
                                                <label className="custom-control-label" htmlFor="tercerosTodos">
                                                    Todos (sin filtro de fechas)
                                                </label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="tercerosDesde">Fecha ingreso desde</label>
                                            <input
                                                id="tercerosDesde"
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={tercerosDesde}
                                                disabled={tercerosTodos}
                                                onChange={(e) => setTercerosDesde(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="tercerosHasta">Fecha ingreso hasta</label>
                                            <input
                                                id="tercerosHasta"
                                                type="date"
                                                className="form-control form-control-sm"
                                                value={tercerosHasta}
                                                disabled={tercerosTodos}
                                                onChange={(e) => setTercerosHasta(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="card-footer bg-white">
                                        <button type="button" className="btn btn-info btn-block" onClick={exportarTerceros} disabled={exportando === 'terceros'}>
                                            <i className="fas fa-file-csv mr-1"></i>
                                            {exportando === 'terceros' ? 'Generando…' : 'Descargar'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 mb-4">
                                <div className="card h-100">
                                    <div className="card-header" style={{ background: '#eaeaea' }}>
                                        <h3 className="card-title mb-0">
                                            <i className="fas fa-file-invoice-dollar mr-2"></i>Facturas
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-muted small">
                                            Comprobantes contables de facturas (sin borradores ni anuladas).
                                        </p>
                                        <div className="form-group">
                                            <label htmlFor="facturasDesde">Fecha desde</label>
                                            <input id="facturasDesde" type="date" className="form-control form-control-sm" value={facturasDesde} onChange={(e) => setFacturasDesde(e.target.value)} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="facturasHasta">Fecha hasta</label>
                                            <input id="facturasHasta" type="date" className="form-control form-control-sm" value={facturasHasta} onChange={(e) => setFacturasHasta(e.target.value)} />
                                        </div>
                                        {selectorUsuario('facturasUsuario', facturasUsuario, setFacturasUsuario)}
                                        {camposDebitoCredito('facturas', facturasDebito, setFacturasDebito, facturasCredito, setFacturasCredito)}
                                    </div>
                                    <div className="card-footer bg-white">
                                        <button type="button" className="btn btn-info btn-block" onClick={exportarFacturas} disabled={exportando === 'facturas'}>
                                            <i className="fas fa-file-csv mr-1"></i>
                                            {exportando === 'facturas' ? 'Generando…' : 'Descargar'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4 mb-4">
                                <div className="card h-100">
                                    <div className="card-header" style={{ background: '#eaeaea' }}>
                                        <h3 className="card-title mb-0">
                                            <i className="fas fa-file-excel mr-2"></i>Notas crédito
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        <p className="text-muted small">
                                            Asiento inverso de ventas por notas crédito.
                                        </p>
                                        <div className="form-group">
                                            <label htmlFor="ncDesde">Fecha desde</label>
                                            <input id="ncDesde" type="date" className="form-control form-control-sm" value={ncDesde} onChange={(e) => setNcDesde(e.target.value)} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="ncHasta">Fecha hasta</label>
                                            <input id="ncHasta" type="date" className="form-control form-control-sm" value={ncHasta} onChange={(e) => setNcHasta(e.target.value)} />
                                        </div>
                                        {selectorUsuario('ncUsuario', ncUsuario, setNcUsuario)}
                                        {camposDebitoCredito('nc', ncDebito, setNcDebito, ncCredito, setNcCredito)}
                                    </div>
                                    <div className="card-footer bg-white">
                                        <button type="button" className="btn btn-info btn-block" onClick={exportarNc} disabled={exportando === 'nc'}>
                                            <i className="fas fa-file-csv mr-1"></i>
                                            {exportando === 'nc' ? 'Generando…' : 'Descargar'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="alert mt-1 mb-4"
                            style={{
                                background: 'rgba(23, 162, 184, 0.08)',
                                border: '1px solid rgba(23, 162, 184, 0.22)',
                                color: '#2b3440',
                                borderRadius: '12px',
                            }}
                        >
                            <div className="d-flex align-items-start">
                                <i className="fas fa-info-circle mr-2 mt-1" style={{ color: '#17a2b8' }}></i>
                                <div className="mb-0 flex-grow-1">
                                    <p className="mb-2">
                                        Las facturas generadas en SmileWeb utilizan las siguientes cuentas contables:
                                    </p>
                                    <ul className="mb-2 pl-3">
                                        <li><strong>1105 – Caja:</strong> para pagos en efectivo.</li>
                                        <li><strong>1110 – Bancos:</strong> para pagos realizados a través de entidades financieras.</li>
                                        <li><strong>1305 – Cuentas por cobrar:</strong> para valores pendientes de pago.</li>
                                        <li><strong>4165 – Ventas:</strong> para el registro de ingresos por ventas.</li>
                                        <li><strong>4175 – Devoluciones:</strong> utilizada para las notas crédito.</li>
                                    </ul>
                                    <p className="mb-2">
                                        <strong>Código de producto:</strong> cuando la factura contiene RIPS, el sistema utiliza automáticamente el código RIPS correspondiente.
                                    </p>
                                    <p className="mb-2">
                                        <strong>Importante:</strong> no se incluyen facturas en estado Borrador ni Anulada.
                                    </p>
                                    <p className="mb-0">
                                        En los movimientos Débito/Crédito, el usuario puede definir o forzar los códigos contables requeridos para la integración con Siigo (por ejemplo, 13 y 41).
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ExportarSiigo;
